angular.module('dnecom')
    .controller('ProductImportCsvModalController', ["$scope", "$uibModalInstance", "$http", "notifications", "storeId", function ($scope, $uibModalInstance, $http, notifications, storeId) {
        var vm = this;
        vm.step = 1;
        $scope.invalidFile = false;
        $scope.tableData = [];
        $scope.mapped = [];
        $scope.fileName = null;
        $scope.file = null;
        $scope.result = {};
        $scope.mappingError = [];
        $scope.categories = [];
        $scope.selectedCategory = null;
        $scope.selectedCategoryObject = null;
        $scope.allowedMimeTypes = [
            'text/plain',
            'text/x-csv',
            'application/vnd.ms-excel',
            'application/csv',
            'application/x-csv',
            'text/csv',
            'text/comma-separated-values',
            'text/x-comma-separated-values',
            'text/tab-separated-values',
            '',
        ];
        $scope.mapping = [
            {
                key: 'product_name',
                title: 'Product name',
                required: true,
                multiple: false,
            },
            {
                key: 'product_title',
                title: 'Product title',
                required: false,
                multiple: false,
            },
            {
                key: 'regular_price',
                title: 'Regular price',
                required: false,
                multiple: false,
            },
            {
                key: 'current_price',
                title: 'Current price',
                required: true,
                multiple: false,
            },
            {
                key: 'quantity',
                title: 'Quantity',
                required: false,
                multiple: false,
            },
            {
                key: 'short_product_description',
                title: 'Short product description',
                required: false,
                multiple: false,
            },
            {
                key: 'main_product_description',
                title: 'Main product description',
                required: false,
                multiple: false,
            },
            {
                key: 'extra_description',
                title: 'Extra description',
                required: false,
                multiple: false,
            },
            {
                key: 'product_images',
                title: 'Main product image',
                required: false,
                multiple: false,
            },
            {
                key: 'additional_product_images',
                title: 'Additional product images',
                required: false,
                multiple: false,
            },
            {
                key: 'variant_standard',
                title: 'Product variants - Standard',
                required: false,
                multiple: true,
            },
            {
                key: 'variant_color',
                title: 'Product variants - Color',
                required: false,
                multiple: true,
            },
            {
                key: 'variant_size',
                title: 'Product variants - Size',
                required: false,
                multiple: false,
            },
            {
                key: 'variant_style',
                title: 'Product variants - Style',
                required: false,
                multiple: true,
            },
            {
                key: 'product_source_url',
                title: 'Product source URL',
                required: false,
                multiple: false,
            },
            {
                key: 'product_source_price',
                title: 'Product source price',
                required: false,
                multiple: false,
            },
            {
                key: 'google_category',
                title: 'Google category',
                required: false,
                multiple: false,
            },
        ];

        $http.get(Routing.generate('api_categories_list', {store: storeId})).then(function (response) {
            $scope.categories = response.data;
        })

        $scope.categoryOptions = {
            tags: true,
        };

        $scope.categorySelected = function () {
            let cat = null;
            try {
                cat = JSON.parse($scope.selectedCategory);
            } catch (exc) {
                cat = {
                    id: -1,
                    name: $scope.selectedCategory,
                }
            }

            if (cat) {
                if (cat.id === -1) {
                    $scope.selectedCategory = JSON.stringify(cat);
                    $scope.categories.push(cat);
                }

                $scope.selectedCategoryObject = cat;
            }
        };

        $scope.previous = function(form) {
            vm.step = vm.step - 1 || 1;
        };

        $scope.next = function(form) {
            $scope.tableData.length ? vm.step = 2 : $scope.invalidFile = true;
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.uploadCsv = function (file) {
            $scope.invalidFile = false;
            if (!file || !$scope.allowedMimeTypes.includes(file.type)) {
                $scope.invalidFile = true;
                return;
            }
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.file = btoa(evt.target.result);
            }
            reader.readAsBinaryString(file);
            Papa.parse(file, {
                complete: function(results) {
                    $scope.fileName = file.name;
                    $scope.tableData = results.data;
                    vm.step = 2;
                    $scope.$apply();
                }
            });
        }

        $scope.setMap = function (columnName, index) {
            let isMultiple = false;
            $scope.mapping.forEach(function(mapItem) {
                if (mapItem.key === $scope.mapped[index] && mapItem.multiple) {
                    isMultiple = true;
                }
            });
            if (isMultiple) {
                Array.isArray($scope.result[$scope.mapped[index]])
                    ? $scope.result[$scope.mapped[index]].push(columnName)
                    : $scope.result[$scope.mapped[index]] = [columnName];
            } else {
                for (var key in $scope.result) {
                    if ($scope.result[key] == columnName) delete $scope.result[key];
                }
                for (var key in $scope.mapped) {
                    if ($scope.mapped[key] == $scope.mapped[index] && key != index) $scope.mapped[key] = '';
                }
                $scope.result[$scope.mapped[index]] = columnName;
            }
            for (var key in $scope.result) {
                if (
                    Array.isArray($scope.result[key])
                    && $scope.mapped[index] !== key
                    && $scope.result[key].indexOf(columnName) > -1
                ) {
                    $scope.result[key].splice($scope.result[key].indexOf(columnName), 1)
                    if (!$scope.result[key].length) delete $scope.result[key];
                };
            }

            validate();
        }

        $scope.nextCategory = function() {
            validate();
            if (!$scope.mappingError.length && !$scope.invalidFile) {
                vm.step = 3;
            }
        };

        $scope.process = function() {
            $scope.submitted = true;
            validate();
            if (!$scope.mappingError.length && $scope.selectedCategoryObject && $scope.selectedCategoryObject.name) {
                $http.post(Routing.generate('api_import_product', {
                    store: storeId,
                }), {mapping: $scope.result, file: $scope.file, category: $scope.selectedCategoryObject }).then(function (response) {
                    $uibModalInstance.close('success');
                }, function () {
                    notifications.danger('Something went wrong. Please try again latter');
                })
            }
        };

        function validate() {
            if (vm.step >= 1) {
                $scope.invalidFile = !$scope.tableData.length;
            }
            if (vm.step >= 2) {
                $scope.mappingError = [];
                $scope.mapping.forEach(function(mapItem) {
                    if (mapItem.required && !Object.keys($scope.result).includes(mapItem.key)) {
                        $scope.mappingError.push('Please assign mapping for “' + mapItem.title + '".');
                    }
                })
            }
        }
    }]);
